import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { getQueryParams } from "@obg/ngx.global";
import { Observable } from "rxjs";

import { KycVerificationConfigService } from "./kyc-verification.config";
import { KnowYourCustomerUrlResponse, KycMessage } from "./kyc-verification.model";

@Injectable()
export class KycVerificationService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: KycVerificationConfigService
	) {}

	getKnowYourCustomerUrl(): Observable<KnowYourCustomerUrlResponse> {
		return this.httpClient.get<KnowYourCustomerUrlResponse>({
			url: this.config.getKnowYourCustomerEndpoint(),
		});
	}

	parseMessage(message: string): KycMessage | undefined {
		const searchParams = getQueryParams(message).message;

		try {
			const queryStringMessage = searchParams ? decodeURIComponent(searchParams) : undefined;
			return JSON.parse(queryStringMessage || message);
		} catch {
			return undefined;
		}
	}
}
